module.exports = __webpack_public_path__ + "img/img8.f050a3e3.svg";